import React from 'react';
import { NavLink } from 'react-router-dom';
import Error from '../../Components/UiErrorComponents/Error';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useGetVideosQuery } from '../../features/videos/videosApi';
import SingleVideoTableRow from './SingleVideoTableRow';

const Videos = () => {
    const { data, isLoading, isError, isSuccess } = useGetVideosQuery()
    let content = null
    if (isLoading) {
        content = <Loading className='center-of-window'></Loading>
    } else if (isError) {
        content = <Error error='Something went wrong'></Error>
    } else if (!data?.length) {
        content = <div className='text-center mt-5 text-xl text-error'>
            No data found! please add Video.

        </div>
    } else {
        content = <div className="overflow-x-auto mt-4">
            <table className="divide-y-1 text-base divide-gray-600 w-full">
                <thead>
                    <tr>
                        <th className="table-th">Video Title</th>
                        <th className="table-th">Description</th>
                        <th className="table-th">Action</th>
                    </tr>
                </thead>

                <tbody className="divide-y divide-slate-600/50">
                    {
                        data?.map(single => <SingleVideoTableRow key={single.id} data={single}></SingleVideoTableRow>)
                    }
                </tbody>
            </table>
        </div>
    }
    return (
        <section className="py-6 bg-primary">
            <div className="mx-auto max-w-full px-5 lg:px-20">
                <div className="px-3 py-20 bg-opacity-10">
                    <div className="w-full flex">
                        <NavLink to='/admin/addVideo' className="btn ml-auto">Add Video</NavLink>
                    </div>
                    {content}
                </div>
            </div>
        </section>
    );
};

export default Videos;